import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators'

import { urlRep } from 'src/app/common';
import { ReportT3 } from 'src/app/models/obs/report';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) { }

  countTier3(id: string) {
    return this.http.get(`${urlRep}/${id}`);
  }

  callTier3Counter(id: number) {
    return this.http.get(`${urlRep}/${id}`);
  }

  reportT3(id: number) {
    return this.http.get(`${urlRep}/report/${id}`).pipe(
      map((res: ReportT3) => res) // do stuff with res here, but it *will map to whatever you return from this handler*
    );
  }

}
